<template>
    <div v-bind:class="{'overlay' : loadingCount>0}"></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    components: {

    },
    watch:{
        loadingCount(value){
        }
    },
    computed: Object.assign({
            },
            mapGetters({
                'loadingCount':'shell/LoadingCount'
            }),
        )
}
</script>
<style>
    .overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("../assets/hourglass_small.gif") center center no-repeat;
        z-index: 2;
        cursor: pointer;
    }
</style>